// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProviderTransactionSortType,
    SupportCreateTransactionPayload,
    SupportTransactionSortType,
    Transaction,
    SupportCreateTransactionPayloadToJSON,
    TransactionFromJSON,
} from '../models';

export interface CreateSupportTransactionRequest {
    supportCreateTransactionPayload: SupportCreateTransactionPayload;
}

export interface GetProviderTransactionRequest {
    id: string;
}

export interface GetSupportTransactionRequest {
    id: string;
}

export interface ListProviderTransactionsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderTransactionsOrderEnum>;
    filterCreated?: Array<string>;
    filterInvoiceGroupId?: Array<string>;
    sort?: Array<ProviderTransactionSortType>;
}

export interface ListSupportTransactionsRequest {
    filterClaimId?: Array<string>;
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportTransactionsOrderEnum>;
    filterCreated?: Array<string>;
    filterInvoiceGroupId?: Array<string>;
    sort?: Array<SupportTransactionSortType>;
}

/**
 * no description
 */
export class TransactionApi extends runtime.BaseAPI {

    /**
     * Create a transaction
     * Create a transaction
     */
    async createSupportTransactionRaw(requestParameters: CreateSupportTransactionRequest): Promise<runtime.ApiResponse<Transaction>> {
        if (requestParameters['supportCreateTransactionPayload'] === null || requestParameters['supportCreateTransactionPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateTransactionPayload','Required parameter requestParameters.supportCreateTransactionPayload was null or undefined when calling createSupportTransaction.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:transaction", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/transaction`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateTransactionPayloadToJSON(requestParameters['supportCreateTransactionPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TransactionFromJSON(jsonValue));
    }

    /**
     * Create a transaction
     * Create a transaction
     */
    async createSupportTransaction(requestParameters: CreateSupportTransactionRequest): Promise<Transaction> {
        const response = await this.createSupportTransactionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get transaction
     * Get transaction
     */
    async getProviderTransactionRaw(requestParameters: GetProviderTransactionRequest): Promise<runtime.ApiResponse<Transaction>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderTransaction.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:transaction"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/transaction/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TransactionFromJSON(jsonValue));
    }

    /**
     * Get transaction
     * Get transaction
     */
    async getProviderTransaction(requestParameters: GetProviderTransactionRequest): Promise<Transaction> {
        const response = await this.getProviderTransactionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get transaction
     * Get transaction
     */
    async getSupportTransactionRaw(requestParameters: GetSupportTransactionRequest): Promise<runtime.ApiResponse<Transaction>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportTransaction.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:transaction", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/transaction/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TransactionFromJSON(jsonValue));
    }

    /**
     * Get transaction
     * Get transaction
     */
    async getSupportTransaction(requestParameters: GetSupportTransactionRequest): Promise<Transaction> {
        const response = await this.getSupportTransactionRaw(requestParameters);
        return await response.value();
    }

    /**
     * List transactions
     * List transactions
     */
    async listProviderTransactionsRaw(requestParameters: ListProviderTransactionsRequest): Promise<runtime.ApiResponse<Array<Transaction>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterInvoiceGroupId) {
            queryParameters['filterInvoiceGroupId'] = requestParameters.filterInvoiceGroupId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:transaction"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/transaction`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TransactionFromJSON));
    }

    /**
     * List transactions
     * List transactions
     */
    async listProviderTransactions(requestParameters: ListProviderTransactionsRequest): Promise<Array<Transaction>> {
        const response = await this.listProviderTransactionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * List transactions
     * List transactions
     */
    async listSupportTransactionsRaw(requestParameters: ListSupportTransactionsRequest): Promise<runtime.ApiResponse<Array<Transaction>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterInvoiceGroupId) {
            queryParameters['filterInvoiceGroupId'] = requestParameters.filterInvoiceGroupId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:transaction", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/transaction`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TransactionFromJSON));
    }

    /**
     * List transactions
     * List transactions
     */
    async listSupportTransactions(requestParameters: ListSupportTransactionsRequest): Promise<Array<Transaction>> {
        const response = await this.listSupportTransactionsRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderTransactionsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportTransactionsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
